/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useRouter } from 'next/router'
import { SyntheticEvent, useState } from 'react'
import { PieChart } from 'react-minimal-pie-chart'

import SVGImage from '~/components/Image/SVGImage'
import { ProgressBarData } from '~/statistics/types/product-card.types'

interface Props {
  progressBarData: ProgressBarData[]
  totalSlices: number
  imgSrcKey: string
  imgAltText: string
}

const mediaQuery = [{ screen: '(min-width: 280px)', width: '60vw' }]

export default function PieProgress({
  progressBarData,
  totalSlices,
  imgSrcKey,
  imgAltText,
}: Props): React.ReactElement {
  const router = useRouter()

  const [hovered, setHovered] = useState<number | null>(null)
  const data = progressBarData.map((entry, i) => {
    if (hovered === i) {
      return {
        ...entry,
        color: 'grey',
      }
    }
    return entry
  })

  const handleClick = (e: SyntheticEvent, index: any): void => {
    const { videoLink } = progressBarData[index]
    router.push(videoLink as string)
  }

  return (
    <div className="relative h-24">
      <PieChart
        data={data}
        onClick={handleClick}
        onMouseOut={() => {
          setHovered(null)
        }}
        onMouseOver={(_, index) => {
          setHovered(index)
        }}
        radius={49}
        segmentsShift={1}
        segmentsStyle={() => ({
          transition: 'stroke .3s',
          cursor: 'pointer',
        })}
        startAngle={270}
        totalValue={totalSlices}
      />
      <SVGImage
        alt={imgAltText}
        imageClassName="absolute w-13 top-8 left-0 right-0 mx-auto"
        mediaQuery={mediaQuery}
        srcKey={imgSrcKey}
      />
    </div>
  )
}
